import React from "react";
import "./AppMessageElement.scss";
import moment from "moment";

const AppMessageElement = (props) => {
  let dateFormat = "y-MM-dd";
  let datetimeFormat = "y-MM-dd HH:mm:ss";
  return (
    <div className="app-message">
      {/* <img src={props.image} /> */}
      <span
        style={{ fontSize: "13px", fontWeight: 700 }}
      >{`${props.title}`}</span>
      <span
        style={{
          fontSize: "10px",
          fontWeight: 700,
          color: "#747474",
          float: "right",
        }}
      >
        {moment(props.creationTime).format("HH:mm")}
      </span>
      <div style={{ fontSize: "10px" }}>{props.text}</div>
    </div>
  );
};
export default AppMessageElement;
